var settingsServices =
webpackJsonp_name_([10],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(69);


/***/ },

/***/ 69:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(70);

/***/ },

/***/ 70:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _settingsPanel = __webpack_require__(71);

	var _settingsPanel2 = _interopRequireDefault(_settingsPanel);

	var _visibilityPanel = __webpack_require__(72);

	var _visibilityPanel2 = _interopRequireDefault(_visibilityPanel);

	var _publicApi = __webpack_require__(18);

	var _publicApi2 = _interopRequireDefault(_publicApi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var loader = {
	    name: 'us:settings',

	    extends: 'uScope',

	    // TODO: Consider reworking the registration of this service.
	    constructor: function Thinger(uScope) {
	        _classCallCheck(this, Thinger);

	        var settingsPanel = new _settingsPanel2.default(uScope);
	        // HACK ALERT - mutating uScope
	        uScope.visibilityPanel = new _visibilityPanel2.default(uScope, settingsPanel);
	    }
	};

	_publicApi2.default.plugins.register(loader);

/***/ },

/***/ 71:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = SettingsPanel;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _events = __webpack_require__(10);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function SettingsPanel(uScope) {
	    var self = this;
	    var jPanel;
	    var jRoot = $(_defines2.default.idHashROOT);

	    //............................................ setSliderQuality() local
	    // setSliderQuality - This function sets the image quality on the preferences tab.
	    self.setSliderQuality = function (quality) {
	        var jHandle = $('#' + _defines2.default.idPREFQUALITYSLIDER).find('.ui-slider-handle');
	        jHandle.text(quality);
	    };

	    //............................................ show() public
	    self.show = function (show) {
	        if (show == false) {
	            jPanel.dialog('close');
	            return;
	        }
	        jPanel.dialog('open');
	        // Force the dialog to center on each open; otherwise it occasionally appears at the top of the viewport.
	        jPanel.dialog({ position: { my: 'center', at: 'center', of: jRoot } });

	        // .............................................................report tab
	        // insure that the current prefs are displayed
	        $('#' + _defines2.default.idREPORTFIXEDWIDTH).val(String(uScope.prefGet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx)));
	        $('#' + _defines2.default.idREPORTFIXEDHEIGHT).val(String(uScope.prefGet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx)));

	        var reportType = +uScope.prefGet('reportRegionType', 0);
	        $('.' + _defines2.default.clsREPORTTYPE)[reportType].checked = 'checked'; // check current report type

	        // .............................................................image info tab
	        var link = '';
	        $('#' + _defines2.default.idLINKTEXTBOX).html(link);
	        var imageInfo = _getImageInformation();
	        $('#' + _defines2.default.idTABIMAGEINFO).html(imageInfo);

	        // .............................................................preferences tab
	        if (_defines2.default.ENABLETHUMBHOVER) {
	            var checked = uScope.prefGet(_defines2.default.clsDIVTHUMBHOVER);
	            $('#' + _defines2.default.idTHHOVERCHECKBOX).prop('checked', checked); // check thumbnail enlarge on hover checkbox
	        }

	        _defines2.default.viewPrefs = {
	            'quality': 75,
	            'defQuality': 75
	        };
	        uScope.prefSet('imageQuality', _defines2.default.viewPrefs.quality);

	        $('#' + _defines2.default.idPREFQUALITYSLIDER).slider({
	            value: _defines2.default.viewPrefs.quality,
	            step: 5,
	            // the slide fn gets range 50 to 100 with these settings
	            min: 45,
	            max: 105,
	            slide: function slide(event, ui) {
	                _defines2.default.viewPrefs.quality = $(this).slider('value');
	                $(ui.handle).text(_defines2.default.viewPrefs.quality);
	            },
	            stop: function stop(event, ui) {
	                uScope.prefSet('imageQuality', _defines2.default.viewPrefs.quality);
	            }
	        });
	        self.setSliderQuality(uScope.prefGet('imageQuality')); // set the image quality on the slider handle
	    };
	    //............................................ _getImageInformation() local
	    //improvement:
	    //    - use accessors provided by viewport
	    var _getImageInformation = function _getImageInformation() {
	        var imageInfo = 'No Image Selected';
	        if (uScope.isThisImageValid() == true) {
	            var thisImg = uScope.getThisImage();
	            var xinfo = thisImg.getXinfoObj();

	            imageInfo = 'Scanner: ' + thisImg.getScanner() + '<br>File: ' + thisImg.getFileName() + '<br>Image ID: ' + thisImg.getImageId() + '<br>Image Type: ' + _defines2.default.captureNames[thisImg.getCaptureType()];
	            if (xinfo.isFused) {
	                for (var i = 0; i < xinfo.fusedFiles.length; i++) {
	                    imageInfo += '<br>&nbsp;&nbsp; Member File: ' + xinfo.fusedFiles[i];
	                }
	            }

	            imageInfo += '<br><br>Image dimensions (pixels): ' + thisImg.getImageDims().toString2() + '<br>Tile dimensions (pixels): ' + thisImg.getXinfoObj().tileWidth + ' x ' + thisImg.getXinfoObj().tileHeight + '<br>Image Resolution (microns/pixel) : ' + thisImg.getBaseMPP() + '<br>Image Magnification : ' + thisImg.getMaximumMag() + 'x' + '<br>Image Normalization Factor : ' + _defines2.default.helpers.roundToDecimals(thisImg.getNormalizationFactor(), 2) + '<br>Image Depth : ' + xinfo.depth + '<br>Image Channels: ' + (xinfo.isFused ? xinfo.fusedFiles.length : xinfo.samplPerPix) + '<br>Image Bit Depth: ' + xinfo.bitsPerSampl;
	            if (xinfo.acqBitsPerSampl) imageInfo += '<br>Acquisition Bit Depth: ' + xinfo.acqBitsPerSampl;

	            //cp-is there value in the AIL description?
	            //        var fullDesc = thisImg.getImageDescription();
	            //        if (fullDesc && fullDesc.indexOf("Aperio Image Library") != -1) {    // Aperio Image Library v12.0.8
	            //            var idx = fullDesc.indexOf("v");
	            //            var idx2 =  fullDesc.indexOf(" ", idx)
	            //            var vers = fullDesc.slice(idx,idx2);
	            //            imageInfo += "<br><br>Library: Aperio Image Library " + vers;
	            //        }

	            if (thisImg.getFileTypeDesc()) imageInfo += '<br><br>File/Compression Type: ' + thisImg.getFileTypeDesc();
	            if (thisImg.getCompQuality()) imageInfo += '<br>Compression Quality: ' + thisImg.getCompQuality();
	            if (thisImg.getImageICCProfile()) imageInfo += '<br>ICC Profile: ' + thisImg.getImageICCProfile();
	            if (thisImg.getScanScopeId()) imageInfo += '<br>Scanner: ' + thisImg.getScanScopeId();
	            if (thisImg.getImageDate()) imageInfo += '&nbsp;&nbsp;Date: ' + thisImg.getImageDate();

	            if (_defines2.default.ENABLELINKTOIMAGE == true) {
	                // link to this image
	                // format example: http:  //localhost/view.html?fullURL=//aperio-00824:82/@@bYOUR_TOKEN_HERE==/@5&x=9360&y=9371&mag=20
	                //                 http:  //localhost/view.html?fullURL=/imageserver/@@bYOUR_TOKEN_HERE==/@2
	                var sImgSrc = thisImg.getFullURL() ? thisImg.getFullURL() : thisImg.getServer() + thisImg.getImageId();
	                // send "normal" graphics coords
	                var linkValue = 'http://' + window.location.hostname + '/view.html?fullURL=' + sImgSrc + '&x=' + thisImg.getViewCenterX(true) + '&y=' + thisImg.getViewCenterY(true) + '&mag=' + thisImg.getViewMag();
	                //debug-onlyconsoleWrite("link: " + linkValue);
	                var imageLinkDOM = $('<div>').prepend('<br>').append($('<button>', { id: _defines2.default.idCOPYLINKBTN }).append($('<span>', {
	                    id: _defines2.default.idLINKIMAGE
	                })).append('Copy Image Link')).after('<br>').after($('<div>', { id: _defines2.default.idLINKTEXTBOX, title: 'Current image link.' }).append(linkValue));
	                var imageLink = $('<div>').append(imageLinkDOM.clone()).html(); // convert to string
	                imageInfo += imageLink;
	            }
	        }
	        return imageInfo;
	    };
	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the settings panel event handlers.
	    var bindEvents_ = function bindEvents_() {
	        // bind imageupdate and close this panel if it is open
	        jRoot.on(_defines2.default.evIMAGEUPDATE, function (e, parms) {
	            // always close the options dialog when image changes
	            if (jPanel.is(':visible') && jPanel.hasClass('ui-dialog-content')) {
	                jPanel.dialog('close');
	            }
	        });

	        // user preference update
	        jRoot.on(_defines2.default.evUSERPREFDEFAULTREPORT + '.report', function (e, parms) {
	            //consoleWrite("report us.evUSERPREFDEFAULTREPORT recvd");
	            uScope.prefSet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx);
	            uScope.prefSet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx);
	            uScope.prefSet('reportRegionType', _defines2.default.eReportSpec.defReportType);
	            // update the panel
	            $('#' + _defines2.default.idREPORTFIXEDWIDTH).val(String(uScope.prefGet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx)));
	            $('#' + _defines2.default.idREPORTFIXEDHEIGHT).val(String(uScope.prefGet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx)));

	            var reportType = +uScope.prefGet('reportRegionType');
	            $('.' + _defines2.default.clsREPORTTYPE)[reportType].checked = 'checked';
	        });

	        //............................................ settings panel, pref buttons
	        jRoot.on('click', '#' + _defines2.default.idTHHOVERCHECKBOX, function (e) {
	            // change thumbnail hover pref
	            // the checked state into this fn is the changed state
	            //consoleWrite("Hover check box : checked: " + this.ch+ecked);
	            uScope.prefSet(_defines2.default.clsDIVTHUMBHOVER, this.checked);
	        });
	        jRoot.on('click', '.' + _defines2.default.clsPREFBUTTON, function (e) {
	            var target = e.currentTarget.id;
	            //if (us.DBGOPTIONS) consoleWrite("save user preferences: " + target);
	            if (target === _defines2.default.idPREFLABELROTBTN) {
	                var thisImg = uScope.getThisImage(); //multi-image - note that all images must be updated here
	                if (thisImg) uScope.prefSet('labelRotation', thisImg.label.getViewAngle());
	            } else if (target == _defines2.default.idPREFDEFAULTBTN) {
	                // default pref tab
	                (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFDEFAULTLABELROT, { status: true }); // fire event to default label rotation
	                (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFDEFAULTTHUMBHOVER, { status: true }); // fire event to default thumbnail hover enlargement
	            } else if (target == _defines2.default.idRPTDEFAULTBTN) {
	                // default report tab
	                if (_defines2.default.DBGTOOLBAR) (0, _toolbar.consoleWrite)('report default click');
	                (0, _events.triggerUScopeEvent)(_defines2.default.evUSERPREFDEFAULTREPORT, { status: true }); //fire event
	            } else if (target == _defines2.default.idPTESTREPORTBTN) {
	                // performance test report
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    var svObj = thisImg.stateVector;
	                    var report = svObj.reportAll(_defines2.default.eStateTypes.view, true);
	                    if (report.length > 0) {
	                        var report2 = report.replace(/\r\n|\n\r|\r|\n/g, '<br>');
	                        (0, _toolbar.genericMessage)(report2, 'Current Sequence');
	                    }
	                    (0, _toolbar.consoleWrite)(report);
	                }
	            } else if (target == _defines2.default.idPTESTRUNBTN) {
	                // performance test run
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    if (thisImg.getPerfTestObj().isRunning() == false) {
	                        // not running, start it
	                        var idxTest = $('.' + _defines2.default.clsPERFTESTOPTION).filter(':checked').val();
	                        var useRecorded = $('.' + _defines2.default.clsPERFTESTINTERVAL).filter(':checked').val() == '0' ? true : false;
	                        var interval = $('#' + _defines2.default.idPERFTESTINTERVAL).val(); // get the interval to run with
	                        var running = thisImg.getPerfTestObj().run(+idxTest, useRecorded, +interval);
	                        $('#' + _defines2.default.idPTESTRUNBTN).text('Stop');
	                    } else {
	                        // already running, stop it
	                        thisImg.getPerfTestObj().stop();
	                        $('#' + _defines2.default.idPTESTRUNBTN).text('Run');
	                    }
	                }
	            } else if (target == _defines2.default.idPTESTSHOWBTN) {
	                // performance test save results
	                if (uScope.isThisImageValid()) {
	                    var thisImg = uScope.getThisImage();
	                    var report = thisImg.getPerfTestObj().getTestReport();
	                    if (report.length > 0) {
	                        var report2 = report.replace(/\r\n|\n\r|\r|\n/g, '<br>');
	                        (0, _toolbar.genericMessage)(report2, 'Test Results');
	                    }
	                    (0, _toolbar.consoleWrite)(report);
	                }
	            }
	        });
	        //............................................ settings panel, report tab
	        jRoot.on('change', '#' + _defines2.default.idREPORTFIXEDWIDTH + ',#' + _defines2.default.idREPORTFIXEDHEIGHT, function (e) {
	            var target = e.currentTarget.id;
	            var value = +$('#' + target).val();
	            //if (us.DBGTOOLBAR) consoleWrite("report region size change:" + target + "  val=" + value);

	            // if the value is out of bounds, revert to the prior value and inform the user
	            if (value < _defines2.default.eReportSpec.minDimPx || value > _defines2.default.eReportSpec.maxDimPx) {
	                if (target == _defines2.default.idREPORTFIXEDWIDTH) {
	                    $('#' + target).val(String(uScope.prefGet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx)));
	                    var dim = 'width';
	                } else {
	                    $('#' + target).val(String(uScope.prefGet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx)));
	                    var dim = 'height';
	                }
	                var msg = 'The fixed report region ' + dim + ' must be between ' + _defines2.default.eReportSpec.minDimPx + ' and ' + _defines2.default.eReportSpec.maxDimPx + ' pixels.';
	                (0, _toolbar.genericMessage)(msg, 'Value Out of Bounds');
	            } else {
	                // otherwise keep the change and update the prefs
	                if (target == _defines2.default.idREPORTFIXEDWIDTH) uScope.prefSet('reportRegionWidth', value);else uScope.prefSet('reportRegionHeight', value);
	            }
	        });
	        jRoot.on('click', '.' + _defines2.default.clsREPORTTYPE, function (e) {
	            var target = e.currentTarget;
	            var value = $(target).val();
	            //if (us.DBGTOOLBAR) consoleWrite("report type click: " + value);
	            uScope.prefSet('reportRegionType', value);
	        });
	    };

	    //............................................ init_() local
	    //    init_ - This function creates and intializes the settings panel.
	    var init_ = function init_() {
	        if (jPanel != undefined) jPanel.remove();
	        jPanel = $('<div/>', {
	            'class': _defines2.default.clsPANEL + ' ' + _defines2.default.clsPANELCLICKCLOSE,
	            'title': 'Options',
	            css: { 'overflow-y': 'hidden', 'max-height': 560 }
	        });

	        var reportTab = initReportTab_();
	        var prefsTab = initPrefsTab_();
	        var imageinfoTab = '<div id=' + _defines2.default.idIMAGEINFODIV + '>' + '</div>';
	        var hotkeysTab = initHotKeysTab_();
	        var aboutTab = uScope.getProgName() + '&nbsp;&nbsp;&nbsp;&nbsp;Version: ' + uScope.getProgVersion() + '<br/>' + uScope.getProgDate();
	        var perftestTab = 'PERFORMANCE_TAB_PLACEHOLDER';

	        var tabStr = // make tabs and their panel
	        '<div id=' + _defines2.default.idSETTINGSTABS + '>' + '<ul>';
	        tabStr += '<li><a href="\#' + _defines2.default.idTABHOTKEYS + '">Keyboard Shortcuts</a></li>' + '<li><a href="\#' + _defines2.default.idTABPREFERENCES + '">Preferences</a></li>' + '<li><a href="\#' + _defines2.default.idTABREPORT + '">Report</a></li>' + '<li><a href="\#' + _defines2.default.idTABIMAGEINFO + '">Image</a></li>' + '<li><a href="\#' + _defines2.default.idTABABOUT + '">About</a></li>';
	        if (_defines2.default.ENABLEPERFTEST == true) tabStr += '<li><a href="\#' + _defines2.default.idTABPERFTEST + '">Performance</a></li>';
	        tabStr += '</ul>';

	        tabStr += '<div id=' + _defines2.default.idTABHOTKEYS + '>' + hotkeysTab + '</div>' + '<div id=' + _defines2.default.idTABPREFERENCES + '>' + prefsTab + '</div>' + '<div id=' + _defines2.default.idTABREPORT + '>' + reportTab + '</div>' + '<div id=' + _defines2.default.idTABIMAGEINFO + '>' + imageinfoTab + '</div>' + '<div id=' + _defines2.default.idTABABOUT + '>' + aboutTab + '</div>';
	        if (_defines2.default.ENABLEPERFTEST == true) tabStr += '<div id=' + _defines2.default.idTABPERFTEST + '>' + perftestTab + '</div>';
	        tabStr += '</div>';

	        var jTabs = $(tabStr); // create the tab jq object
	        jPanel.append(jTabs); // add the tabs to the panel

	        jPanel.dialog({ // call to create the dialog. Make it modal or the image link can get out of sync with the selected image
	            autoOpen: false,
	            modal: false,
	            draggable: true,
	            stack: true,
	            resizable: false,
	            width: 'auto',
	            dialogClass: 'uscope-dialog dialogMover',
	            appendTo: jRoot,
	            position: { my: 'center', at: 'center', of: jRoot },
	            open: function open(event, ui) {
	                $('#' + _defines2.default.idSETTINGSTABS).tabs({
	                    heightStyle: 'auto',
	                    activate: function activate(event, ui) {

	                        if (ui.newPanel && ui.newPanel.selector === '#' + _defines2.default.idTABPERFTEST) {
	                            var html = initPerformanceTab_();
	                            ui.newPanel.html(html);
	                        }

	                        if (ui.newPanel && ui.newPanel.selector == '#' + _defines2.default.idTABIMAGEINFO) {
	                            // call to create the tabs; tab content should fill the height of the dialog for consistency
	                            var imageLink = ui.newPanel.find('#' + _defines2.default.idLINKTEXTBOX);
	                            selectText(imageLink); // select the link URL by default (so it is easy for user to manually copy)
	                            var copyButton = ui.newPanel.find('#' + _defines2.default.idCOPYLINKBTN);
	                            try {
	                                if (copyButton.length > 0 && document.queryCommandSupported('copy') && document.queryCommandEnabled('copy')) {
	                                    copyButton.on('click', function () {
	                                        try {
	                                            selectText(imageLink); // Select the image link again in case it was de-selected
	                                            var successful = document.execCommand('copy'); // Execute the copy command if available
	                                            var msg = successful ? 'The image link was copied to the clipboard.' : 'There was a problem copying the image link. Use Ctrl-c instead.';
	                                            alert(msg);
	                                        } catch (err) {
	                                            var thisImg = uScope.getThisImage();
	                                            thisImg.err('cSettingsPanel: init: The copy link command threw an exception.');
	                                        }
	                                    });
	                                }
	                            } catch (err) {
	                                if (copyButton.is(':visible')) {
	                                    copyButton.hide(); // Hide copy link button if not supported
	                                    imageLink.before('<p>Link to this image. Press Ctrl-c (or Cmd-c on a Mac) to copy to the clipboard.</p>');
	                                }
	                            }
	                        }
	                    }
	                });
	            }
	        });

	        bindEvents_(); // add event handlers
	    };

	    //............................................ initPrefsTab_() local
	    // improvements;
	    //        option for magnifier diameter
	    //        option for jpeg tile quality
	    //        option for autopan speed
	    var initPrefsTab_ = function initPrefsTab_() {

	        var labelTTip = 'Apply the current label rotation to all images when opened';
	        var imgQualtyTTip = 'Set the download image quality. Default is ' + '75.';
	        var advancedTTip = 'Open advanced settings panel.';
	        var defaultTTip = 'Reset above preferences to defaults.';

	        var space = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
	        var prefs = '<div><span class="' + _defines2.default.clsSETCHOICE + '" title="' + labelTTip + '">Label Rotation<button class="' // label rotation pref
	        + _defines2.default.clsPREFBUTTON + '" id="' + _defines2.default.idPREFLABELROTBTN + '" type="button">Use Current</button></span></div>';

	        if (_defines2.default.ENABLETHUMBHOVER == true) {
	            prefs += '<br><span>Thumbnail Enlarge on Hover&nbsp;&nbsp;&nbsp;&nbsp;</span>'; // thumbnail hover pref
	            prefs += '<input id="' + _defines2.default.idTHHOVERCHECKBOX + '"  type="checkbox" name="us.idTHHOVERCHECKBOX" value="us.idTHHOVERCHECKBOX"/><br>';
	        }

	        if (_defines2.default.ENABLEIMAGEQUALITYSETTING) {
	            prefs += '\n<div class="' + _defines2.default.clsSETCHOICE + '" title="' + imgQualtyTTip + '">\n    <span>Image Quality</span>\n    <div id="' + _defines2.default.idPREFQUALITYSLIDER + '" title="' + imgQualtyTTip + '"></div>\n</div>';

	            prefs += '<br><br><div><span class="' + _defines2.default.clsSETCHOICE + '" title="' + defaultTTip + '">' + space + '<button class="' // default prefs
	            + _defines2.default.clsPREFBUTTON + '" id="' + _defines2.default.idPREFDEFAULTBTN + '" type="button">Default</button></span></div>';

	            prefs += '<br><br><div class=\'tooldivider\'></div>'; // horizontal line
	        }
	        prefs += '<br>';
	        return prefs;
	    };

	    //............................................ initReportTab_() local
	    var initReportTab_ = function initReportTab_() {
	        var defaultTTip = 'Reset above preferences to defaults.';
	        var report = '<div id="' + _defines2.default.idREPORTFIXEDDIV + '">' + '<div>&nbsp;&nbsp;&nbsp;<b>Fixed Region Size</b> (in pixels)</div>' + '<br>&nbsp;&nbsp;' + '<span>Width&nbsp;&nbsp;</span><input id="' + _defines2.default.idREPORTFIXEDWIDTH + '" type="text" value=' + String(uScope.prefGet('reportRegionWidth', _defines2.default.eReportSpec.defWidthPx)) + '/>' + '&nbsp;&nbsp;&nbsp;&nbsp;' + '<span>Height&nbsp;&nbsp;</span><input id="' + _defines2.default.idREPORTFIXEDHEIGHT + '" type="text" value=' + String(uScope.prefGet('reportRegionHeight', _defines2.default.eReportSpec.defHeightPx)) + '/>' + '<br></div>' + '<br><Input type = radio Name = rptType class ="' + _defines2.default.clsREPORTTYPE + '" Value="0" checked> Full Resolution Image,&nbsp; Fixed Sized Report Region' + '<br><Input type = radio Name = rptType class ="' + _defines2.default.clsREPORTTYPE + '" Value="1"> Full Resolution Image,&nbsp; User Drawn Report Region' + '<br><Input type = radio Name = rptType class ="' + _defines2.default.clsREPORTTYPE + '" Value="2"> Current Image Resolution,&nbsp; Fixed Sized Report Region' + '<br><Input type = radio Name = rptType class ="' + _defines2.default.clsREPORTTYPE + '" Value="3"> Current Image Resolution,&nbsp; User Drawn Report Region' + '<br><br>' + '<div class="' + _defines2.default.clsSETCHOICE + '"><span><button class="' + _defines2.default.clsPREFBUTTON + '" Title="' + defaultTTip + '" id="' + _defines2.default.idRPTDEFAULTBTN + '"  type="button">Default</button></span><br></div>' + '<br>';
	        return report;
	    };
	    //............................................ initPerformanceTab_() local
	    var initPerformanceTab_ = function initPerformanceTab_() {
	        var perftest;
	        if (_defines2.default.ENABLEPERFTEST == true) {
	            var thisImg = uScope.getThisImage();
	            var reportSeqTTip = 'Report the current navigation sequence';
	            var runTTip = 'Execute the selected performance test';
	            var showTTip = 'Display the test results';

	            var spacing = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
	            var nameList = thisImg.getPerfTestObj().getTestNames();
	            perftest = '&nbsp;&nbsp;<span><b>Test Sequence</b></span>';

	            for (var n = 0; n < nameList.length; n++) {
	                var atest = void 0;
	                if (n == nameList.length - 1) {
	                    atest = '<br>' + spacing + '<Input type = radio Name = perfTest class ="' + _defines2.default.clsPERFTESTOPTION + '" Value="' + n + '" checked>&nbsp; ' + nameList[n];
	                } else {
	                    atest = '<br>' + spacing + '<Input type = radio Name = perfTest class ="' + _defines2.default.clsPERFTESTOPTION + '" Value="' + n + '">&nbsp; ' + nameList[n];
	                }
	                perftest += atest;
	            }
	            perftest += '<br><br>';
	            perftest += '&nbsp;&nbsp;<span><b>Test Interval</b></span>';

	            perftest += '<br>' + spacing + '<Input type = radio Name = perfInterval class ="' + _defines2.default.clsPERFTESTINTERVAL + '" Value="0"> Recorded Interval' + '<br>' + spacing + '<Input type = radio Name = perfInterval class ="' + _defines2.default.clsPERFTESTINTERVAL + '" Value="1"  checked> Specified Interval';
	            perftest += '&nbsp;&nbsp;<span>(msec)&nbsp;&nbsp;</span><input id="' + _defines2.default.idPERFTESTINTERVAL + '" type="text" value=' + 3000 + '/>';

	            perftest += '<br>';
	            perftest += '<div class="' + _defines2.default.clsSETCHOICE + '" title="' + runTTip + '">Selected Test<span><button class="' + _defines2.default.clsPREFBUTTON + '" id="' + _defines2.default.idPTESTRUNBTN + '" type="button"><b>Run</b></button></span></div>';

	            perftest += '<div class="' + _defines2.default.clsSETCHOICE + '" title="' + showTTip + '">Test Results<span><button class="' + _defines2.default.clsPREFBUTTON + '" id="' + _defines2.default.idPTESTSHOWBTN + '" type="button">Display</button></span></div>';

	            perftest += '&nbsp;&nbsp;&nbsp;&nbsp;<div class="tooldivider"></div>';
	            perftest += '<div class="' + _defines2.default.clsSETCHOICE + '" title="' + reportSeqTTip + '">Current Sequence<span><button class="' + _defines2.default.clsPREFBUTTON + '" id="' + _defines2.default.idPTESTREPORTBTN + '" type="button">Report</button></span></div>';
	        }
	        return perftest;
	    };

	    //............................................ initHotKeysTab_() local
	    var initHotKeysTab_ = function initHotKeysTab_() {
	        // arrow key navigation:    Move the image in view up,down,left,right 1/4 of the view width,height.
	        //                            If the shift key is down, Move the image in view up,down,
	        //                            left,right 3/4 of the view width,height.
	        // control - navigation:    zoom out
	        // control + navigation:    zoom in
	        //
	        // delete:                    delete selected annotation
	        // r:                        rotate cw +15 degrees
	        // shift r:                    rotate cw +1 degrees
	        // control r:                rotate ccw +15 degrees
	        // control shift r:            rotate ccw +1 degrees
	        // 0, num0:                    set rotation to 0 degrees

	        var hotkeys = '<div id="' + _defines2.default.idTABHOTKEYS + '">' + '<table><tbody>' + '<tr><td><h4>Slide Change</h4></td></tr> ' + '<tr><td>q, Q</button></td><td>Step to the previous slide in the tray</td></tr>' + '<tr><td>e, E</button></td><td>Step to the next slide in the tray</td></tr>' + '<tr><td>&nbsp;</td></tr>' + '<tr><td><h4>View Navigation</h4></td></tr> ' + '<tr><td>Arrow Keys</td><td>Move the view 1/4 of the view width,height</td></tr>' + '<tr><td>Shift + Arrow Keys</td><td>Move the view 3/4 of the view width,height</td></tr>' + '<tr><td>&nbsp;</td></tr>' + '<tr><td><h4>View Magnification</h4></td></tr>' + '<tr><td>Control -</td><td>Zoom Out</td></tr>' + '<tr><td>Control +</td><td>Zoom In</td></tr>' + '<tr><td>Double-Click</td><td>Toogle between the last two magnfications</td></tr>' + '<tr><td>&nbsp;</td></tr>' + '<tr><td><h4>View Rotation</h4></td></tr> ' + '<tr><td>r</td><td>Rotate CW +15 degrees</td></tr>' + '<tr><td>Shift R</td><td>Rotate CW +1 degrees</td></tr>' + '<tr><td>Control r</td><td>Rotate CCW +15 degrees</td></tr>' + '<tr><td>Control Shift R</td><td>Rotate CCW +1 degrees</td></tr>' + '<tr><td>0 (zero)</td><td>Set rotation to 0 degrees</td></tr>' + '<tr><td>&nbsp;</td></tr>' + '<tr><td><h4>Annotations</h4></td></tr> ' + '<tr><td>Control m</td><td>Toggle move/pin selected annotation</td></tr>' + '<tr><td>Control c</td><td>Copy selected annotation</td></tr>' + '<tr><td>Control v</td><td>Paste copied or selected annotation</td></tr>' + '<tr><td>Delete</td><td>Delete selected annotation</td></tr>' + '</tbody></table>' + '</div><br>';
	        return hotkeys;
	    };
	    //............................................ construction
	    init_();
	}

	var selectText = function selectText(element) {
	    if (element.length > 0) {
	        element = element[0];
	        var range = void 0,
	            selection = void 0;

	        if (document.body.createTextRange) {
	            range = document.body.createTextRange();
	            range.moveToElementText(element);
	            range.select();
	        } else if (window.getSelection) {
	            selection = window.getSelection();
	            range = document.createRange();
	            range.selectNodeContents(element);
	            selection.removeAllRanges();
	            selection.addRange(range);
	        }
	    }
	};
	module.exports = exports['default'];

/***/ },

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = VisibilityPanel;

	var _defines = __webpack_require__(3);

	var _defines2 = _interopRequireDefault(_defines);

	var _toolbar = __webpack_require__(5);

	var _events = __webpack_require__(10);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function VisibilityPanel(uScope, settingsPanel) {
	    var jRoot;
	    var jPanel;
	    var jParent;
	    var jVizAllCheckBox; // the "check all" checkbox
	    var jVizCheckBoxes; // array of all viz check boxes
	    var isVisibilityPanelOpen = false;

	    //............................................ check() public
	    //    This function shows/hides the specified overlay
	    //    using the visibility checkboxes    which updates the user preferences.

	    this.check = function (clsOverlay, bCheck) {
	        var isVisible = isOverlayVisible_(clsOverlay);
	        if (bCheck == isVisible) // if the checkbox is already in the desired state, return
	            return;

	        for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
	            if (clsOverlay == jVizCheckBoxes[b].name) {
	                jVizCheckBoxes[b].click(); // set the visibility check box to the desired checked state
	                break;
	            }
	        }
	    };

	    //............................................ toggleVisibilityPanel_() local
	    //    This function shows/hides the visibility panel
	    var toggleVisibilityPanel_ = function toggleVisibilityPanel_() {
	        isVisibilityPanelOpen = !isVisibilityPanelOpen;

	        if (isVisibilityPanelOpen) {
	            jPanel.dialog('open');

	            // position the fly out panel
	            var rootPos = jRoot.offset(); // root div position relative to the document
	            var thisImg = uScope.getThisImage();
	            if (thisImg) {
	                var crOffset = thisImg.toolbar.getOffsetRect();
	                jParent.offset({ 'left': rootPos.left + crOffset.x, 'top': rootPos.top + crOffset.y });
	            } else {
	                jParent.offset({ 'left': rootPos.left + 2, 'top': rootPos.top + 2 });
	            }

	            for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
	                // set the visibility check boxes checked state
	                jVizCheckBoxes[b].checked = isOverlayVisible_(jVizCheckBoxes[b].name);
	                //debug-only consoleWrite(b + " " + clsOverlay + " " + isVisible);
	            }

	            jVizAllCheckBox[0].checked = areAllVisible_(); // set the "all checked" check box
	        } else {
	            jPanel.dialog('close');
	        }
	    };

	    //............................................ isOverlayVisible_() local
	    var isOverlayVisible_ = function isOverlayVisible_(clsOverlay) {
	        var rtnVisible = false;
	        if (clsOverlay == _defines2.default.clsDIVGUAGES) // because the tilemeter auto-hides, get its current preference
	            rtnVisible = uScope.prefGet(_defines2.default.clsDIVGUAGES);else if (clsOverlay == _defines2.default.CVSHEATMAP) rtnVisible = uScope.prefGet(_defines2.default.CVSHEATMAP);else rtnVisible = $('.' + clsOverlay).is(':visible');
	        return rtnVisible;
	    };
	    //............................................ countOverlayVisible() local
	    var countOverlayVisible_ = function countOverlayVisible_() {
	        var vizCount = 0; // count of the number of overlays visible
	        for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
	            // set the visibility check boxes checked state
	            var isVisible = isOverlayVisible_(jVizCheckBoxes[b].name);
	            if (isVisible == true) vizCount++;
	        }
	        return vizCount;
	    };
	    //............................................ areAllVisible_() local
	    var areAllVisible_ = function areAllVisible_() {
	        return countOverlayVisible_() == jVizCheckBoxes.length;
	    };
	    //............................................ bindEvents_() local
	    // bindEvents_ - This function adds the configuration panel event handlers.
	    //
	    //    Note that an exception is made here and the namespace is not an image's namespace.

	    var bindEvents_ = function bindEvents_() {
	        var namespace = '.toolbar';
	        var selector = '.' + _defines2.default.TBSETTINGS + '-';
	        selector = selector + 'e, ' + selector + 'a';

	        //............................................ visibility panel open/close
	        jRoot.on('click' + namespace, selector, function (e) {
	            toggleVisibilityPanel_();
	            (0, _toolbar.setIconState)($('#' + _defines2.default.TBSETTINGS), _defines2.default.TBSETTINGS, isVisibilityPanelOpen ? 'active' : 'enabled');
	            return false; // prevents autopan from activating
	        });

	        jRoot.on('click' + namespace, '#' + _defines2.default.idOPTIONSBTN, function (e) {
	            // open options panel
	            settingsPanel.show(true);
	            // If the user is opening the settings dialog, he probably isn't interested in the visibility panel anymore.
	            toggleVisibilityPanel_();
	        });

	        jRoot.on('click' + namespace, '#' + _defines2.default.idVIZALLCHECKBOX, function (e) {
	            // the checked state into this fn is the changed state
	            // consoleWrite("cVisibilityPanel: all: " + this.name + " value: " + this.value + " checked: " + this.checked);

	            if (areAllVisible_() == true) {
	                // if all visible now,  hide all
	                for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
	                    jVizCheckBoxes[b].click();
	                }
	            } else {
	                for (var b = 0, len = jVizCheckBoxes.length; b < len; b++) {
	                    var isVisible = isOverlayVisible_(jVizCheckBoxes[b].name);
	                    if (isVisible == false) jVizCheckBoxes[b].click();
	                }
	            }
	        });

	        jPanel.on('change' + namespace, '.' + _defines2.default.clsVIZCHECKBOX, function (e) {
	            //debug-only consoleWrite("cVisibilityPanel: change: name: " + this.name + " value: " + this.value + " checked: " + this.checked);
	            uScope.prefSet(this.name, this.checked); // setting pref triggers evUSERPREFSET
	            jVizAllCheckBox[0].checked = areAllVisible_(); // set the "all checked" check box

	            uScope.overlayRefresh(); // arrange all overlays of all views
	            uScope.setImageSelected(uScope.getSelImageIdx(), true); // now force selection to hide overlays on non-selected images
	        });

	        jRoot.on('click' + namespace, '#' + _defines2.default.idHMCLEARBTN, function (e) {
	            // thumbnail heat map clear
	            (0, _events.triggerUScopeEvent)(_defines2.default.evHEATMAPCLEAR, {});
	        });
	    };

	    //............................................ init_() local
	    var init_ = function init_() {
	        jRoot = $(_defines2.default.idHashROOT);
	        jPanel = $('<div id="us_idconfigpanel" class=' + _defines2.default.clsPANEL + ' ' + _defines2.default.clsPANELCLICKCLOSE + '></div>');
	        jRoot.append(jPanel); // first must add the panel to the root to be able to move it
	        jPanel.dialog({
	            autoOpen: false, title: 'Visibility', closeOnEscape: true, draggable: false, stack: true, resizable: false,
	            dialogClass: 'uscope-dialog',
	            width: 160,
	            close: function close() {
	                // Make sure isVisibilityPanelOpen is in sync with the state of the dialog.
	                isVisibilityPanelOpen = false;
	            }
	        });

	        // append this dialog to uscope's root div - the dialog is the parent to the panel created
	        jPanel.parent().appendTo(_defines2.default.idHashROOT);

	        var html = '';

	        // use a template and replace scheme to build the visibility check box list
	        var checkboxes = '<div>';
	        checkboxes += '<br><label><input id="' + _defines2.default.idVIZALLCHECKBOX + '"  type="checkbox" title="Select All"  name="ALLOVERLAYS" value="All"/> All</label>';

	        var template = '<br><label><input class="' + _defines2.default.clsVIZCHECKBOX + '" type="checkbox" title="TIP"  name="OVERLAYCLASS" value="OVERLAYCLASS"/> TEXT </label>';
	        if (uScope.canViewLabel()) checkboxes += template.replace('TIP', 'Image Label').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVLABEL).replace('NUM', 0).replace('TEXT', 'Label');
	        if (_defines2.default.ENABLEMAG == true) checkboxes += template.replace('TIP', 'Magnifier Glass').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVMAG).replace('NUM', 1).replace('TEXT', 'Magnifier Glass');
	        if (_defines2.default.ENABLEROTATION == true) checkboxes += template.replace('TIP', 'Rotation Dial').replace(/OVERLAYCLASS/g, _defines2.default.clsROTATIONDIV).replace('NUM', 2).replace('TEXT', 'Rotation Dial');
	        if (_defines2.default.ENABLESCALEBAR == true) checkboxes += template.replace('TIP', 'Scale Bar').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVSCALEBAR).replace('NUM', 3).replace('TEXT', 'Scale Bar');
	        if (_defines2.default.ENABLETILEMETER) checkboxes += template.replace('TIP', ' Tile Meter').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVGUAGES).replace('NUM', 4).replace('TEXT', ' Tile Meter');
	        if (_defines2.default.ENABLETHUMB == true) checkboxes += template.replace('TIP', 'Thumbnail').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVTHUMBNAIL).replace('NUM', 5).replace('TEXT', 'Thumbnail');
	        if (_defines2.default.ENABLEHEATMAP == true) {
	            checkboxes += template.replace('TIP', 'Heat Map').replace(/OVERLAYCLASS/g, _defines2.default.CVSHEATMAP).replace('NUM', 6).replace('TEXT', 'Heat Map');

	            var heatmapClearBtn = '&nbsp;&nbsp;&nbsp;&nbsp;<span><button class="' + 'ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only' + '" Title= "Clear the thumbnail heat map"  id="' + _defines2.default.idHMCLEARBTN + '"  type="button" style="margin: 0px;">&nbsp;Clear&nbsp;</button></span>';
	            checkboxes += heatmapClearBtn;
	        }
	        if (_defines2.default.ENABLEZOOMCTL == true) {
	            checkboxes += template.replace('TIP', 'Zoom Control').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVZOOMCTL).replace('NUM', 7).replace('TEXT', 'Zoom Control');
	            checkboxes += template.replace('TIP', 'Zoom Slider').replace(/OVERLAYCLASS/g, _defines2.default.clsDIVZOOMSLIDER).replace('NUM', 8).replace('TEXT', 'Zoom Slider');
	        }
	        html += checkboxes + '<div>';

	        var horizLine = '<br><div class="tooldivider"></div><br>';
	        var settingsPanelBtn = '&nbsp;&nbsp;&nbsp;&nbsp;<span><button class="' + 'ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only' + '" Title= "Configuration options"  id="' + _defines2.default.idOPTIONSBTN + '"  type="button" style="margin: 0;">&nbsp;&nbsp;Options&nbsp;&nbsp;</button></span>';
	        html += horizLine + settingsPanelBtn;

	        jPanel.html(html);

	        jVizCheckBoxes = jPanel.find('.' + _defines2.default.clsVIZCHECKBOX); // get for quick reference
	        jVizAllCheckBox = jPanel.find('#' + _defines2.default.idVIZALLCHECKBOX);
	        jParent = jPanel.parent();

	        bindEvents_(); // add event handlers
	    };

	    //............................................ construction
	    init_();
	}
	module.exports = exports['default'];

/***/ }

});